import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo, { crumbsLd } from "@/components/site/Seo";
import { PageHero } from "@/components/site/Blocks";
import { CtaBand } from "@/components/site/Cta";
import { DemoCard } from "@/components/home/PortfolioCarousel";
import { DEMOS } from "@/data/home";

export default function Portfolio() {
  const crumbs = [{ label: "Home", to: "/" }, { label: "Portfolio e Demo", to: "/portfolio" }];
  return (
    <>
      <Seo path="/portfolio" title="Portfolio e demo di siti web | STUDIO WEB NS"
        description="Sei stili di sito per bar, parrucchieri, abbigliamento, botteghe, showroom e artigiani: identità grafiche diverse e funzioni pensate per ogni settore." jsonLd={crumbsLd(crumbs)} />
      <PageHero crumbs={crumbs} eyebrow="Portfolio e demo" title="Sei settori, sei identità diverse." intro="Anteprime di interfacce con attività fittizie. Le demo navigabili sono in arrivo: nessuna attività reale, nessuna recensione inventata.">
        <Link to="/richiedi-anteprima" data-testid="portfolio-preview-btn" className="btn-primary">Richiedi un’anteprima <ArrowRight className="h-4 w-4" /></Link>
      </PageHero>
      <section className="sec bg-soft">
        <div className="wrap grid gap-x-5 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 [&>a]:w-full">
          {DEMOS.map((d) => <DemoCard key={d.key} d={d} />)}
        </div>
      </section>
      <CtaBand title="Vuoi vedere un’anteprima per la tua attività?" wa="anteprima" />
    </>
  );
}
